import { render, staticRenderFns } from "./Sancionadas.vue?vue&type=template&id=583fdb40&"
import script from "./Sancionadas.vue?vue&type=script&lang=js&"
export * from "./Sancionadas.vue?vue&type=script&lang=js&"
import style0 from "./Sancionadas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports